<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="page-content">
        <div class="layout">
    <app-back-button></app-back-button>
    <div class="page-header">
      <h1 class="page-title">{{ 'playlists.title' | t }}</h1>
      <p class="subtitle">{{ 'playlists.subtitle' | t }}</p>
      <div class="tokens" *ngIf="tokens">
        Tokens: {{ tokens.remaining }} / {{ tokens.allowance }}<span *ngIf="tokens.used" class="muted"> · usados {{ tokens.used }}</span>
        <a class="token-link" routerLink="/app/tokens">¿Qué son los tokens?</a>
      </div>
    </div>

    <div *ngIf="loading" class="glass-card placeholder">
      <ion-spinner></ion-spinner>
      <div class="subtitle">{{ 'playlists.loading' | t }}</div>
    </div>

          <div class="grid">
            <app-playlist-card *ngFor="let playlist of playlists" [playlist]="playlist" (delete)="delete($event)"></app-playlist-card>
          </div>

          <div class="pagination" *ngIf="!loading && playlists.length">
            <button class="secondary-futuristic" [disabled]="page === 1" (click)="prevPage()">&lt;</button>
            <div class="page-indicator">Page {{ page }} / {{ totalPages() }}</div>
            <button class="secondary-futuristic" [disabled]="page * limit >= total" (click)="nextPage()">&gt;</button>
          </div>

          <div class="ad-out">
            <app-ad-slot placement="playlists"></app-ad-slot>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
